import { createSlice } from "@reduxjs/toolkit";
import { getTabData, getTabList, createOrUpdateTab, deleteTab ,getTermsData} from "./ThunkActions";
import { iPageSectionState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iPageSectionState = {
  isLoading: false,
  tabDetail: null,
  tabList: [],
  errorMessage: null,
};

export const pageSectionSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetPageSectionState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTabList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTabList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.tabList = payload.data; 
          state.isLoading = false;
        }
      })
      .addCase(getTabList.rejected, (state) => {
        state.errorMessage = "Failed to fetch tabs";
        state.isLoading = false;
      })
      .addCase(getTabData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTabData.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.tabDetail = payload.data; 
          state.isLoading = false;
        }
      })
      .addCase(getTabData.rejected, (state) => {
        state.errorMessage = "please fill page data";
        state.isLoading = false;
      })
      .addCase(createOrUpdateTab.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createOrUpdateTab.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.tabDetail = payload.data; 
          state.isLoading = false;
        }
      })
      .addCase(createOrUpdateTab.rejected, (state) => {
        state.errorMessage = "Failed to create or update tab";
        state.isLoading = false;
      })
      .addCase(deleteTab.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTab.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.tabList = state.tabList.filter(tab => tab.id !== action.meta.arg.tabId); // Remove the deleted tab from the list
          state.isLoading = false;
        }
      })
      .addCase(deleteTab.rejected, (state) => {
        state.errorMessage = "Failed to delete tab";
        state.isLoading = false;
      })
      
      .addCase(getTermsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTermsData.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.tabDetail = payload.data; 
          state.isLoading = false;
        }
      })
      .addCase(getTermsData.rejected, (state) => {
        state.errorMessage = "please fill page data";
        state.isLoading = false;
      })
      ;
  },
});

export const { resetPageSectionState } = pageSectionSlice.actions;
export default pageSectionSlice.reducer;